"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_5 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_6 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_7 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_8 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const bmk_ui_framework_9 = require("@biomemakers/bmk_ui_framework");
const trans_1 = require("@common/tsutils/trans");
const ModuleChangePayload_1 = __importDefault(require("@becrop/components/Modules/Common/Models/ModuleChangePayload"));
let TableProposalsRow = class TableProposalsRow extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.stages = [
            {
                code: 'gis_file_upload',
                title: 'Gis File Upload',
            },
            {
                code: 'calculating_zones',
                title: 'Calculating Zones (BMK)',
            },
            {
                code: 'sample_collecting',
                title: 'Sample Collecting (User)',
            },
            {
                code: 'sample_shipping',
                title: 'Sample Shipping (User)',
            },
            {
                code: 'lab_received',
                title: 'Lab received (Lab BMK)',
            },
            {
                code: 'lab_dna_extraction',
                title: 'DNA extracted (Lab BMK)',
            },
            {
                code: 'lab_pcr',
                title: 'PCR-ed (Lab BMK)',
            },
            {
                code: 'lab_pool',
                title: 'Pool-ed (Lab BMK)',
            },
            {
                code: 'lab_sequenced',
                title: 'Sequenced (Lab BMK)',
            },
            {
                code: 'lab_quality_control',
                title: 'Quality Control (Lab BMK)',
            },
            {
                code: 'metadata',
                title: 'Metadata Upload (User)',
            },
            {
                code: 'result',
                title: 'Result (BMK)',
            },
        ];
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    emitLoadProposal(event) {
        this.$emit('emitLoadProposal', event);
    }
    get isTrials() {
        let value = false;
        const typeKeys = ['trials'];
        return this.proposal.deliverables.some((d) => typeKeys.includes(d.type));
    }
    get isStudy() {
        let value = false;
        const typeKeys = ['study'];
        return this.proposal.deliverables.some((d) => typeKeys.includes(d.type));
    }
    get proposalSamples() {
        var _a;
        const proposalSamples = (_a = this.proposal.deliverables_details) === null || _a === void 0 ? void 0 : _a.find((d) => d.type === 'trials' || d.type === 'study');
        return proposalSamples;
    }
    get totalSamples() {
        var _a, _b, _c, _d, _e;
        return (((_a = this.proposalSamples) === null || _a === void 0 ? void 0 : _a.samples.analized) +
            ((_b = this.proposalSamples) === null || _b === void 0 ? void 0 : _b.samples.at_lab) +
            ((_c = this.proposalSamples) === null || _c === void 0 ? void 0 : _c.samples.pending_lab_but_sent) +
            ((_d = this.proposalSamples) === null || _d === void 0 ? void 0 : _d.samples.pending_metadata) +
            ((_e = this.proposalSamples) === null || _e === void 0 ? void 0 : _e.samples.pending_send));
    }
    get percentageSamplesCompleted() {
        var _a;
        let total = (this.totalSamples < 1) ? 0 : this.totalSamples;
        return (((_a = this.proposalSamples) === null || _a === void 0 ? void 0 : _a.samples.analized) / total) * 100;
    }
    get samplesCompleted() {
        var _a;
        return (_a = this.proposalSamples) === null || _a === void 0 ? void 0 : _a.samples.analized;
    }
    get trialsDecorator() {
        var _a, _b;
        const actionRequiredNum = ((_a = this.proposalSamples) === null || _a === void 0 ? void 0 : _a.samples.pending_send) +
            ((_b = this.proposalSamples) === null || _b === void 0 ? void 0 : _b.samples.pending_metadata);
        if (this.samplesCompleted === this.totalSamples && this.samplesCompleted > 0)
            return 'success';
        if (actionRequiredNum > 0)
            return 'primary';
        return 'info';
    }
    get trialsStatus() {
        var _a, _b;
        const actionRequiredNum = ((_a = this.proposalSamples) === null || _a === void 0 ? void 0 : _a.samples.pending_send) +
            ((_b = this.proposalSamples) === null || _b === void 0 ? void 0 : _b.samples.pending_metadata);
        if (this.samplesCompleted === this.totalSamples && this.samplesCompleted > 0)
            return 'completed';
        if (actionRequiredNum > 0)
            return 'action_required';
        return 'ontrack';
    }
    get proposalStageNumber() {
        const stageIx = this.stages.findIndex((s) => { var _a, _b; return s.code === ((_b = (_a = this.proposal) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.slug); });
        return stageIx;
    }
    get proposalStatus() {
        var _a, _b, _c, _d;
        if ((_b = (_a = this.proposal) === null || _a === void 0 ? void 0 : _a.status) === null || _b === void 0 ? void 0 : _b.phase.toLowerCase().includes('user')) {
            return 'action_required';
        }
        else if ((_d = (_c = this.proposal) === null || _c === void 0 ? void 0 : _c.status) === null || _d === void 0 ? void 0 : _d.phase.toLowerCase().includes('bmk')) {
            return 'ontrack';
        }
        return 'completed';
    }
    get explainHint() {
        var _a;
        let hint = '';
        if (this.isTrials) {
            if (this.trialsStatus == 'action_required') {
                hint =
                    this.samplesCompleted +
                        ' ' +
                        (0, trans_1.trans)('tracking.trials_hint.analyzed') +
                        ' ' +
                        ((_a = this.proposal.deliverables_details.find((d) => d.type === 'trials')) === null || _a === void 0 ? void 0 : _a.samples.pending_send) +
                        ' ' +
                        (0, trans_1.trans)('tracking.trials_hint.from_you');
            }
            if (this.trialsStatus == 'ontrack') {
                hint =
                    this.samplesCompleted +
                        ' ' +
                        (0, trans_1.trans)('tracking.trials_hint.ongoing') +
                        ' ' +
                        (this.totalSamples - this.samplesCompleted);
            }
            if (this.trialsStatus == 'completed') {
                hint = (0, trans_1.trans)('tracking.trials_hint.completed');
            }
        }
        else {
            if (this.isStudy) {
                hint = this.trialsStatus == 'completed' ?
                    (0, trans_1.trans)('tracking.study_hint.completed') :
                    (0, trans_1.trans)('tracking.study_hint.pending');
            }
            else {
                switch (this.proposalStatus) {
                    case 'action_required':
                        hint =
                            (0, trans_1.trans)('tracking.hint.req') +
                                ' ' +
                                (0, trans_1.trans)('tracking.life_cycles.' +
                                    this.proposal.status.slug +
                                    '.title');
                        break;
                    case 'ontrack':
                        hint = (0, trans_1.trans)('tracking.hint.ontrack');
                        break;
                    case 'completed':
                        hint = (0, trans_1.trans)('tracking.hint.completed');
                        break;
                }
            }
        }
        return hint;
    }
    // This might be better calculated from the BE
    get calculateDeliverables() {
        let htmlDeliv = '';
        if (!this.isTrials) {
            this.proposal.deliverables.forEach((d) => {
                htmlDeliv +=
                    '<p><b>' + d.type.toUpperCase() + '</b> (' + d.number + ')</p>';
            });
        }
        else {
            this.proposal.deliverables.forEach((d) => {
                htmlDeliv += '<p><b>' + d.type.toUpperCase() + '</b> (#)</p>';
            });
        }
        return htmlDeliv;
    }
    clickOnTag() {
        if (this.proposalStatus === 'completed' || this.trialsStatus === 'completed') {
            const builtURL = '/results/projects?proposal=' + this.proposal.id;
            const moduleChangePayload = new ModuleChangePayload_1.default({
                originModule: 'tracking',
                destinationModule: 'results',
                url: builtURL,
            });
            this.$emit('switchToResults', moduleChangePayload);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({})
], TableProposalsRow.prototype, "proposal", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableProposalsRow.prototype, "theme", void 0);
TableProposalsRow = __decorate([
    (0, vue_property_decorator_1.Options)({
        emits: ['switchToResults'],
        components: {
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            TableBodyRow: bmk_ui_framework_2.TableBodyRow,
            ProgressBarAlt: bmk_ui_framework_3.ProgressBarAlt,
            ProgressHeadingProposal: bmk_ui_framework_4.ProgressHeadingProposal,
            DateStylized: bmk_ui_framework_6.DateStylized,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            CheckRoundedIcon: bmk_ui_framework_7.CheckRoundedIcon,
            WarningDiamondIcon: bmk_ui_framework_8.WarningDiamondIcon,
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight,
            LoaderBuild: bmk_ui_framework_9.LoaderBuild,
            Tag: bmk_ui_framework_5.Tag,
        },
    })
], TableProposalsRow);
exports.default = TableProposalsRow;
